import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { showError, showSuccess } from "../utils/toast"; // adjust path
import Header from '../components/Header';
import Footer from '../components/Footer';


const Register = () => {
  const navigate = useNavigate();
  const [role, setRole] = useState("Customer"); // New
  const [form, setForm] = useState({
    name: "",
    email: "",
    contactNumber: "",
    password: "",
    confirmPassword: "",
  });

  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

    //setForm({ ...form, [e.target.name]: e.target.value });


  const handleSubmit = async (e) => {
    console.log(e)
    e.preventDefault();
    setError("");

    if (!form || (form.name == '' && form.email ==''&& form.confirmPassword ==''&& form.contactNumber ==''&& form.password=='')) {
      showError("Please fill in all fields.");
      return;
    }

    if (form.password !== form.confirmPassword) {
      showError("Passwords do not match");
      return;
    }

    try {
      const res = await fetch(`${import.meta.env.VITE_API_URL}/api/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          contactNumber: form.contactNumber,
          password: form.password,
          role,
        }),
      });
      console.log("sending data to backend:", {
        name: form.name,
        email: form.email,
        contactNumber: form.contactNumber,
        password: form.password,
        role,
      });
      const data = await res.json();
      console.log(data)
      if (res.ok) {
        showSuccess(`${role} registered successfully!`);
        navigate("/login");
      } else {
        setError(data.msg || "Signup failed");
        showError(data.message|| data.msg || "Signup failed")
      }
    } catch (err) {
      console.error("Signup error:", err);
      showError("Server error. Please try again.");
    }
  };

  return (
    <>
    <Header/>
    <div className='over-nav' style={{height:'100px',background:'#0b7285'}}></div>
    <div className="register-page">
      <div className="left-panel">
        <img src="/happy-family-with-umbrella.webp" alt="Illustration" />
      </div>

      <div className="right-panel">
        <div className="form-box">
          {/* <h1 >Sign Up</h1> */}
          {/* <p>Create your 100% free account and start prototyping with the best tool.</p> */}
                  <div className="logo-section">
                    {/* Header layout: Icon (Left) -> Text (Right) */}
                    <div className="panel-header" style={{display:"flex", justifyContent:"center", alignItems:"flex-start"}}>
                      <Link to="/" className="home-btn" title="Back to Home"  style={{ marginTop:"8px", marginRight:"30%", fontSize:"30px", textDecoration:"none"}}>
                        <i class="fa-solid fa-arrow-left"></i>
                      </Link>
                      <h2 style={{marginRight:"35%"}}>Signup</h2>
                    </div>
                  </div>

          {/* 👇 Toggle Tabs Start */}
          <div className="role-toggle">
            <button
              className={role === "Customer" ? "active" : ""}
              onClick={() => setRole("Customer")}
            >
              <i className="fas fa-user"></i> Customer
            </button>
            <button
              className={role === "Agent" ? "active" : ""}
              onClick={() => setRole("Agent")}
            >
              <i className="fas fa-shield-alt"></i> Agent
            </button>
          </div>
          {/* 👆 Toggle Tabs End */}

          <form  onSubmit={handleSubmit} noValidate>
            <input  type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    placeholder="Full Name"
                    required />
            <div className="two-col">
              <input  type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="Email"
                      required />
              <input type="tel"
                      name="contactNumber"
                      value={form.contactNumber}
                      onChange={handleChange}
                      placeholder="Phone"
                      required />
            </div>
            <div className="two-col">
              <input type="password"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder="Password"
                      required />
              <input type="password"
                      name="confirmPassword"
                      value={form.confirmPassword}
                      onChange={handleChange}
                      placeholder="Confirm Password"
                      required />
            </div>
            <div className="checkbox-line">
              <input type="checkbox" required />
              <label>I agree with the <a href="#">terms of use</a></label>
            </div>
            <button type="submit" className="signup-btn">Signup</button>
          </form>

          <p className="bottom-login">
            Already have an account? <Link to="/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Register;
